<template>
  <div class="header">
    <div class="container">
      <div class="logo">
        <a href="/">
          <img src="../assets/images/logos/Pedrao-22.png">
        </a>

        <h1>PLANO DE GOVERNO <br> COLABORATIVO</h1>
      </div>
      <div class="route">
        <a href="//pedraovereador.com.br">
          <p>VOLTAR PARA O SITE</p>
        </a>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .header {
    width: 100%;
    // box-shadow: 0px 2px 10px 0px rgba(158,158,158,1);
    padding: 10px 20px;
    background-color: transparent;

    .container {
      display: flex;
      width: 100%;
      justify-content: space-between;
      flex-wrap: wrap;


      .logo {
        display: flex;

        h1 {
          margin: 0;
          padding-left: 20px;
          color: #2B2C96;
          font-size: 18px;
        }

        img {
          width: 200px;
        }
      }

      .route {
        p {
          margin: 0;
          padding-top: 15px;
          margin-right: 50px;
          font-weight: 200;
          color: #2B2C96;
          text-transform: uppercase;
          font-size: 15px;
        }

        a {
          text-decoration: none;
        }
      }

      @media (max-width: 1024px) {
        .route {
          width: 100%;
          text-align: center;

          h2 {
            font-size: 20px!important;
          }
        }
      }
    }
  }
</style>
<script>
export default {
  props: ['name'],
};
</script>
